// Income Type State

export default {
  incomeTypeList: [],
  incomeTypeInfo: {},
  fullIncomeTypesList: []
}
